<template>
    <div v-if="show"
        class="fixed inset-0 bg-gray-900 bg-opacity-60 overflow-y-hidden h-full w-full flex items-center justify-center text-base">
        <div class="bg-white rounded-lg shadow-xl w-9/12 h-[85vh] overflow-hidden">
            <div class="flex items-center justify-between p-4 border-b">
                <h2 class="text-2xl text-gray-800 font-semibold">Inventory</h2>
                <button @click="closeModal" class="text-gray-500 hover:text-gray-700" aria-label="Close">
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12">
                        </path>
                    </svg>
                </button>
            </div>

            <div class="p-2 overflow-y-auto">
                    <div>
                    <!-- Tabs -->
                    <div class="mb-4 border-b">
                        <ul class="flex flex-wrap -mb-px">
                            <li v-for="tab in tabs" :key="tab.name" class="mr-2">
                                <a href="#" @click.prevent="currentTab = tab.component"
                                    :class="['inline-block p-4 rounded-t-lg', currentTab === tab.component ? 'border-b-2 border-custom-yellow text-custom-blue' : 'hover:text-gray-600 hover:border-gray-300']">
                                    {{ tab.name }}
                                </a>
                            </li>
                        </ul>
                    </div>

                    <!-- Tab content -->
                    <component :is="currentTab" :prescriptionDetails="prescriptionDetails"></component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PharmaceuticalFormTab from '@/views/tabs/inventory_tabs/PharmaceuticalFormTab.vue';
import NonPharmaceuticalFormTab from '@/views/tabs/inventory_tabs/NonPharmaceuticalFormTab.vue';

export default {
    name: 'CategorySelectionModal',
    components: {
        PharmaceuticalFormTab,
        NonPharmaceuticalFormTab,
    },
    props: {
        show: Boolean,
        prescriptionDetails: Object,
    },
    data() {
        return {
            tabs: [
                { name: 'Pharmaceutical Details', component: 'PharmaceuticalFormTab' },
                { name: 'Non-Pharmaceutical', component: 'NonPharmaceuticalFormTab' },
            ],
            currentTab: 'PharmaceuticalFormTab',
        };
    },
    methods: {
        closeModal() {
            this.$emit('close');
        },
    },
};
</script>